import request from '@/utils/request';

// 查询location_prefecture列表
export function listLocationPrefecture(query) {
  return request({
    url: '/ep2/locationPrefecture/list',
    method: 'get',
    params: query,
  });
}

// 查询location_prefecture详细
export function getLocationPrefecture(id) {
  return request({
    url: `/ep2/locationPrefecture/${id}`,
    method: 'get',
  });
}

// 新增location_prefecture
export function addLocationPrefecture(data) {
  return request({
    url: '/ep2/locationPrefecture',
    method: 'post',
    data,
  });
}

// 修改location_prefecture
export function updateLocationPrefecture(data) {
  return request({
    url: '/ep2/locationPrefecture',
    method: 'put',
    data,
  });
}

// 删除location_prefecture
export function delLocationPrefecture(id) {
  return request({
    url: `/ep2/locationPrefecture/${id}`,
    method: 'delete',
  });
}
